export { default } from './TabRating';